// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ph-5";
export var filledCircle = "_ph-4";
export var historyEntry = "_ph-3";
export var messageSideLeft = "_ph-1";
export var messageSideRight = "_ph-2";
export var orderTrackingCarouselWrapper = "_ph-6";
export var orderTrackingInfoContainer = "_ph-0";